<template lang="pug">
v-layout(row justify-center)
  v-dialog(data-cy="add-modal.dialog" :value="value" @input="$emit('input')" persistent max-width="290")
    v-card
      title-bar(data-cy="add-modal.title" dark) {{ title }}
      v-card-text
        v-text-field(data-cy="add-modal.name" v-model='newResourceName' autofocus)
      v-card-actions
        v-spacer
        v-btn(data-cy="add-modal.cancel" flat @click="closeDialog(false)") Cancel
        v-btn.primary(data-cy="add-modal.submit" @click="closeDialog(true)" :disabled='!isInputValid') Submit
</template>

<script>

import TitleBar from '@/Core/components/TitleBar';

export default {
  components: {
    TitleBar,
  },

  data() {
    return {
      newResourceName: '',
    };
  },

  computed: {
    isInputValid() {
      return this.newResourceName;
    },
  },

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    resourceSingular: {
      type: String,
    },
    title: {
      type: String,
      default: 'add',
    },
  },

  methods: {
    closeDialog(resourceSubmitted = false) {
      if (!resourceSubmitted) {
        this.$emit('input', false);
        this.newResourceName = '';
      }
      if (resourceSubmitted) {
        if (this.newResourceName) {
          this.$emit('input', false);
          this.$emit('close', this.newResourceName, resourceSubmitted);
          this.newResourceName = '';
        }
      }
    },
  },
};

</script>
